import { render, staticRenderFns } from "./epb-aside-form.component.vue?vue&type=template&id=40c932eb&scoped=true"
import script from "./epb-aside-form.component.vue?vue&type=script&lang=ts"
export * from "./epb-aside-form.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-aside-form.component.vue?vue&type=style&index=0&id=40c932eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c932eb",
  null
  
)

export default component.exports